import { AddressSearchContainerControllerBase } from '../search/address_search_container_controller_base';

export default class extends AddressSearchContainerControllerBase {
  initialFocusElement() {
    return this.element.querySelector('input[name="search_fields[StreetAddress][value][]"]');
  }

  // The card inner has a single .field-wrapper wrapping all rows. Collect all
  // non-empty row inputs and join them for the card summary line.
  summarizeRow($row) {
    const values = [];
    $row.find('.multiple-address-street-row input[type=text]').each(function() {
      const val = ($(this).val() || '').toString().trim();
      if (val) values.push(val);
    });
    return values.join(', ');
  }
}
